import "./LoaderSubmission.css";

const LoaderSubmission = () => {
  return (
    <div className="loader-circle loader-circle-hidden">
      <div className="circle-loader circle-1"></div>
      <div className="circle-loader circle-2"></div>
      <div className="circle-loader circle-3"></div>
    </div>
  );
};

export default LoaderSubmission;
